<template>
    <v-card
        v-if="appData"
        class="dialog-card app-store-dialog"
        style="min-height:600px;max-height: calc(100% - 56px)"
    >
        <v-row
            no-gutters
            class="pl-9 pr-4 py-4"
            style="width: 100%; flex-grow: 0"
        >
            <AppStoreDialogHeader
                :show-subscription-info="shouldShowSubscriptionInfo()"
                @close="closeDialog"
            >
            </AppStoreDialogHeader>
        </v-row>
        <v-row class="pl-6 pr-4" no-gutters style="flex-grow: 0">
            <AppStoreDialogTabs />
        </v-row>
        <ScrollShadow>
            <v-row
                no-gutters
                class="pt-2"
            >
                <component
                    :is="getDialogContentByAppName()"
                    :default-tab="defaultTab"
                    @close="closeDialog"
                />
            </v-row>
        </ScrollShadow>
        <AppStoreDialogActions />
    </v-card>
</template>

<script>
import DialogModule from "../../../store/modules/dialog";

import { computed } from "@vue/composition-api";
import { getManifestData } from "@/views/AppStore/app-store-manifest";

import AppStoreDialogHeader from "@/views/AppStore/AppStoreDialog/AppStoreDialogHeader";
import AppLogo from "@/views/AppStore/AppLogo";
import Dialog from "@/components/Dialog";
import appStoreDialogModule from "@/store/modules/AppStoreDialog/appStoreDialog";
import { APP_STORE_APP_TYPES } from "@/helpers/constants";
import AppStoreDialogTabs from "../../../components/AppStore/AppStoreDialogTabs";
import AppStoreDialogActions from "./AppStoreDialogActions";
import ScrollShadow from "@/components/ScrollShadow.vue";

export default {
    name: "AppStoreDialog",
    components: {
        ScrollShadow,
        Dialog,
        AppLogo,
        AppStoreDialogHeader,
        AppStoreDialogTabs,
        AppStoreDialogActions
    },
    props: {
        dialogIndex:{
            type: Number,
            default: 0
        }
    },
    setup(props) {
        const { closeDialog, dialogs } = DialogModule();

        const { appData } = appStoreDialogModule()

        // the props index is coming from dialog index.vue
        const dialogPayload = dialogs.value[props.dialogIndex].payload

        const defaultTab = computed(function(){
            return dialogPayload.defaultTab
        })

        const runCommand = computed(function(){
            return dialogPayload.runCommand
        })

        const shouldShowSubscriptionInfo = function(){
            return ![APP_STORE_APP_TYPES.TASKS,
                     APP_STORE_APP_TYPES.CLIENTS,
                     APP_STORE_APP_TYPES.MINI_UKU].includes(appData.value.name)
        }

        const getDialogContentByAppName = function (){
            return getManifestData(appData.value.name, 'component') || null
        }

        return {
            getManifestData,
            getDialogContentByAppName,
            shouldShowSubscriptionInfo,
            closeDialog,
            appData,
            defaultTab,
            runCommand,
        };
    }
};
</script>

<style scoped lang="scss">
@media screen and (max-height: 700px) {
    .app-store-dialog {
        min-height: unset !important;
    }
}

</style>